import styled, { css } from 'styled-components';

import fonts from '../../../../theme/fonts';
import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';

const getColor = (props) => {
    if (props.variant === 'primary' && !props.isInverted) {
        return promoColors.white;
    } else if (props.variant !== 'primary' && props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.white;
    } else {
        return props.disabled ? promoColors.gray20 : promoColors.primary;
    }
};

const getHoveredColor = (props) => {
    if (props.variant === 'primary' && !props.isInverted) {
        return props.disabled ? promoColors.white : promoColors.primary;
    } else if (props.variant === 'primary' && props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.primary;
    } else if ((props.variant === 'secondary' && props.isInverted) || (props.variant === 'tertiary' && props.isInverted)) {
        return props.disabled ? promoColors.gray20 : promoColors.purple20;
    } else {
        return props.disabled ? promoColors.gray20 : promoColors.purple40;
    }
};

const getBackground = (props) => {
    if (props.variant === 'primary' && !props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.primary;
    } else if (props.variant === 'primary' && props.isInverted) {
        return promoColors.white;
    } else {
        return 'none';
    }
};

const getHoveredBackground = (props) => {
    if (props.variant === 'primary' && !props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.purple20;
    } else if (props.variant === 'primary' && props.isInverted) {
        return props.disabled ? promoColors.white : promoColors.purple20;
    } else {
        return 'none';
    }
};

const getBorderColor = (props) => {
    if (props.variant === 'secondary' && !props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.primary;
    } else if (props.variant === 'secondary' && props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.white;
    }
    return null;
};

const getHoverBorderColor = (props) => {
    if (props.variant === 'secondary' && !props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.purple40;
    } else if (props.variant === 'secondary' && props.isInverted) {
        return props.disabled ? promoColors.gray20 : promoColors.purple20;
    }
    return null;
};

export const IconContainer = styled.span`
    width: 16px;
    height: 16px;
    margin-left: 8px;
`;

const CommonCss = css`
    font-family: ${fonts.medium};
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    color: ${(props) => getColor(props)};
    background: ${(props) => getBackground(props)};
    text-align: center;
    box-shadow: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    vertical-align: top;
    box-sizing: border-box;
    outline: none;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    pointer-events: auto;
    padding: ${(props) => (props.variant === 'tertiary' ? '0' : '0 24px')};
    width: auto;
    height: 40px;
    border-radius: 100px;
    border-width: ${(props) => (props.variant === 'secondary' ? '1px' : '0')};
    border-style: ${(props) => (props.variant === 'secondary' ? 'solid' : null)};
    border-color: ${(props) => (props.variant === 'secondary' ? getBorderColor(props) : null)};

    ${IconContainer} {
        svg {
            --accent: ${(props) => getColor(props)};
            --thickness: 1.6;
        }
    }

    &:link,
    &:visited {
        color: ${(props) => getColor(props)};
    }

    &:hover {
        color: ${(props) => getHoveredColor(props)};
        background: ${(props) => getHoveredBackground(props)};
        border-width: ${(props) => (props.variant === 'secondary' && !props.disabled ? '1px' : '0')};
        border-style: ${(props) => (props.variant === 'secondary' && !props.disabled ? 'solid' : null)};
        border-color: ${(props) => (props.variant === 'secondary' && !props.disabled ? getHoverBorderColor(props) : null)};

        ${IconContainer} {
            svg {
                --accent: ${(props) => getHoveredColor(props)};
            }
        }
    }

    &:active,
    &:focus {
        color: ${(props) => getColor(props)};
        background: ${(props) => getBackground(props)};
        border-color: ${(props) => (props.variant === 'secondary' ? getBorderColor(props) : null)};

        ${IconContainer} {
            svg {
                --accent: ${(props) => getColor(props)};
            }
        }
    }

    &:focus-visible {
        color: ${promoColors.primary};
        background-color: ${promoColors.purple20};
        outline: 1px dashed ${promoColors.primary};
    }

    ${promoMedia.desktop1440} {
        font-size: 16px;
        line-height: 21px;
        height: 48px;

        ${IconContainer} {
            width: 24px;
            height: 24px;
        }
    }
`;

export const CommonButton = styled.button`
    ${CommonCss}
`;

export const LinkButton = styled.a`
    ${CommonCss}
`;

export const PseudoButton = styled.span`
    ${CommonCss}
`;
